import html2canvas from 'html2canvas';

export interface ImageGeneratorOptions {
  width?: number;
  height?: number;
  scale?: number;
  backgroundColor?: string;
}

/**
 * Gera uma imagem a partir de um elemento HTML
 */
export async function generateImageFromElement(
  element: HTMLElement,
  options: ImageGeneratorOptions = {}
): Promise<string> {
  const {
    width = 1080,
    height = 1080,
    scale = 2,
    backgroundColor = '#ffffff',
  } = options;

  // Store original transform and remove it for capture
  const originalTransform = element.style.transform;
  const originalTransformOrigin = element.style.transformOrigin;
  element.style.transform = 'none';
  element.style.transformOrigin = 'initial';

  try {
    const canvas = await html2canvas(element, {
      width,
      height,
      scale,
      backgroundColor,
      useCORS: true,
      logging: false,
      allowTaint: false,
    });

    // Use JPEG with compression to reduce file size (typically 5-10x smaller than PNG)
    // Quality 0.85 provides good visual quality while keeping file size manageable
    return canvas.toDataURL('image/jpeg', 0.85);
  } catch (error) {
    console.error('Erro ao gerar imagem:', error);
    throw new Error('Erro ao gerar imagem');
  } finally {
    // Restore original transform
    element.style.transform = originalTransform;
    element.style.transformOrigin = originalTransformOrigin;
  }
}

/**
 * Converte data URL para Blob
 */
export function dataURLToBlob(dataURL: string): Blob {
  const arr = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/png';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

/**
 * Faz download da imagem gerada
 */
export function downloadImage(dataURL: string, filename: string = 'nutrisync-image.png'): void {
  const blob = dataURLToBlob(dataURL);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Copia imagem para área de transferência
 */
export async function copyImageToClipboard(dataURL: string): Promise<void> {
  try {
    const blob = dataURLToBlob(dataURL);
    await navigator.clipboard.write([
      new ClipboardItem({
        'image/png': blob,
      }),
    ]);
  } catch (error) {
    console.error('Erro ao copiar imagem:', error);
    throw new Error('Não foi possível copiar a imagem para a área de transferência');
  }
}












